import React from 'react';
import './CSS/TypingIndicator.css';
import { connect } from 'react-redux';
import { InnerContainer, TypingContainer } from './CSS/styles';

const TypingIndicator = ({ isTyping }) => {
  return (
    <TypingContainer>
      <InnerContainer>
        <div className={`typing-indicator-container ${isTyping ? 'visible' : 'hidden'}`}>
          <div className="typing-indicator-dot" />
          <div className="typing-indicator-dot" />
          <div className="typing-indicator-dot" />
        </div>
      </InnerContainer>
    </TypingContainer>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile,
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(TypingIndicator);
